import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ModalController, Platform } from "ionic-angular";
import moment from "moment";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";

/**
 * Generated class for the MmseCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "mmse-card",
  templateUrl: "mmse-card.html",
})
export class MmseCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  id: string;
  componentId: string;
  label: string;
  access: string;
  declinable: boolean;
  colHeaders: string[];
  totalGroupings: object;

  rawRow: object = null;
  currentRow: object = null;
  prevRow: object = null;

  constructor(
    public plt: Platform,
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    private alertCtrl: AlertController,
    public translatePipe: TranslateService
  ) {
    // console.log('Hello MmseCardComponent Component');
  }

  ngOnInit(): void {
    // console.log("MMSE card config:", this.config);

    this.id = this.config.id;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.componentId = this.config.componentId;
    this.access = this.config.access;
    this.declinable = this.config.declinable;
    this.colHeaders = this.config.data.listHeaders;

    // Flip from easy configuration format to quick field lookup format
    if (this.config.totalGroupings) {
      let groupings = this.config.totalGroupings;
      let headerMapping = {};

      for (let key of Object.keys(groupings)) {
        for (let item of groupings[key]) {
          headerMapping[item] = key;
        }
      }

      // console.log( "Determined header mapping: ", headerMapping );
      this.totalGroupings = headerMapping;
    }
  }

  @Input() set data(incomingData: any) {
    // console.log( "Form card Data: ", this.data );
    // console.log( "Form card Incoming data: ", incomingData );
    if (incomingData) {
      let cardData = incomingData;
      // console.log("List Card (" + this.id + ") Data received from observable:", cardData);

      if (!cardData.data) {
        return;
      }
      let current = cardData.data[0];
      let previous = cardData.previous;

      if (current) {
        this.rawRow = current;
        this.currentRow = {
          id: current.id,
          values: this.parseDataRow(current),
        };
      }

      if (previous) {
        this.prevRow = this.parseDataRow(previous);
      }
    }
  }

  presentListForm(): void {
    let listModal = this.modalCtrl.create(
      "InputModalPage",
      {
        config: this.config,
      },
      { enableBackdropDismiss: false }
    );
    listModal.onDidDismiss((data) => {
      console.log("GOT DATA BACK!:");
      console.log(data);

      if (data !== undefined) {
        // console.log( "Results!", data );
        // TODO: Add logic to calculate totals and overall score

        let totalGroupings = this.totalGroupings;
        let totalScore = 0;
        for (let key of Object.keys(totalGroupings)) {
          data[key] = Number(data[key]);

          let val = totalGroupings[key];

          if (data[val] === undefined) {
            data[val] = 0 + data[key];
            totalScore += data[key];
          } else {
            data[val] += data[key];
            totalScore += data[key];
          }
          data["totalScore"] = totalScore;
        }

        this.addData(data);
      }
    });
    listModal.present();
  }

  addData(data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .storeRecord(this.assessmentId, this.sectionId, this.id, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from submission:", returnData );
            if (!returnData) {
              return;
            }

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            this.currentRow = newData;
            this.rawRow = returnData;
            // console.log( "Updated raw row: ", this.rawRow );
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  editRow(data: any) {
    // console.log( "Editing row: ", data );

    let modalConfig = { config: this.config };

    let values = this.rawRow;
    if (values !== null || values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};

      for (let key of inputKeys) {
        if (values[key] !== null && values[key] !== undefined) {
          editData[key] = values[key];
        } else {
          editData[key] = null;
        }
      }
      modalConfig["data"] = editData;
    }

    // console.log( "Launching edit with modal config: ", modalConfig );
    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined) {
        let totalGroupings = this.totalGroupings;
        let totalScore = 0;
        for (let key of Object.keys(totalGroupings)) {
          data[key] = Number(data[key]);

          let val = totalGroupings[key];

          if (data[val] === undefined) {
            data[val] = 0 + data[key];
            totalScore += data[key];
          } else {
            data[val] += data[key];
            totalScore += data[key];
          }
          data["totalScore"] = totalScore;
        }

        this.editData(this.currentRow["id"], data);
      }
    });
    listModal.present();
  }

  editData(rowId: string, data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from edit:", returnData );

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            //console.log("Pushing new val.", newData);
            this.currentRow = newData;

            this.rawRow = returnData;
            // console.log( "Updated rawData: ", this.rawData );
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  deleteRow(id: string) {
    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            //console.log( "I'm going to delete: ", id );
            this.dataService
              .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
              .subscribe(() => {
                this.currentRow = null;
              });
          },
        },
      ],
    });
    alert.present();
  }

  parseDataRow(data: object) {
    for (let header of this.colHeaders) {
      // console.log( "Checking header: ", header );
      let val = "-";
      if (data[header] !== undefined && data[header] !== null) {
        if (header === "date" || header === "reportedOn") {
          data[header] = moment(data[header]).format(dateTimeFormat);
        }
        val = data[header];
      }
      // console.log( "Produced val: ", val );
      data[header] = val;
    }
    return data;
  }

  parseDate(dateVal: string) {
    return moment(dateVal).format(dateTimeFormat);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/mmse-card/mmse-card.ts